export default {
  LOGIN: "LOGIN",
  SIGNUP: "SIGNUP",
  IS_LOGGEDIN: "IS_LOGGED_IN",
  SET_ACCOUNT_FIELD: "SET_ACCOUNT_FIELDS",
  SET_HOME_FIELD: "SET_HOME_FIELD",
  SET_USERS: "SET_USERS",
  NEWORDERS_TAB: "NEWORDERS_TAB",
  INPROGRESS_TAB: "INPROGRESS_TAB",
  SHIPMENT_TAB: "SHIPMENT_TAB",
  DELIVERY_TAB: "DELIVERY_TAB",
  NEW_ORDERS: "NEW_ORDERS",
  CLEAR_NEW_ORDERS: "CLEAR_NEW_ORDERS",
  DECREMENT_NEW_ORDERS: "DECREMENT_NEW_ORDERS",
};
